module.exports = __webpack_public_path__ + "media/images/icons/group-d884e351efd1bdf6360439fa73a9f930.svg";